import './styles/site-styles.scss'
import { D_GET_SIGNED_IN_USER, D_SET_TO_USER_CACHE, D_GET_TRANSPORTATION_OWNER } from './utilities/action-types'
import {
  isAuthorized,
  isOnlyInvestor as isOnlyInvestorFn,
  hasTransportationRole,
  getMostRecentTransportationOwnerUser
} from './utilities/helpers'
import {
  C_SET_FOOTER_HEIGHT,
  C_SET_SELECTED_TRANSPORTATION_OWNER,
  C_SET_TOOLBAR_HEIGHT
} from './utilities/mutation-types'

let unwatchUser, unwatchRouteNavigation, unwatchSelectedAccount

export default {
  name: 'App',
  data () {
    return {
      drawer: true,
      fixed: false,
      selectedAccount: null,
      transportationOwnersList: [],
      items: [],
      miniVariant: false,
      title: 'Welcome to SmartTransit',
      signedInUser: null,
      displayNavigationAndMenu: false,
      isTransportationOwnersLoading: false,
      transportationOwnersSearch: '',
      searchKeywords: '',
      rootViewKey: Date.now()
    }
  },
  mounted () {
    this.$nextTick(this.onResize)

    unwatchUser = this.$watch(() => (this ? this.$store?.state?.credentials?.user : null), () => {
      this.initUserAndNavigation()
      this.ensureTransporterSelectedAccount().finally(() => {
        this.items = _populateItemsByUser.call(this)
      })
    })

    unwatchRouteNavigation = this.$watch(() => (this ? this.$route?.meta?.hideNavigation : null), () => {
      this.initUserAndNavigation()
    })

    unwatchSelectedAccount = this.$watch(() => (this ? this.$store.getters.getSelectedTransportationOwner : null), (newVal) => {
      this.selectedAccount = newVal
      if (!newVal) {
        this.ensureTransporterSelectedAccount().finally(() => {
          this.items = _populateItemsByUser.call(this)
        })
      } else {
        this.items = _populateItemsByUser.call(this)
      }
    })

    setTimeout(() => {
      this.items = _populateItemsByUser.call(this)
    }, 2000)

    const token = this.$store.getters.getToken

    if (token && token.expires > Date.now()) {
      this.$store.dispatch(D_GET_SIGNED_IN_USER).catch(_ => {})
    }
    // if transportation owner detected in route param, then set to user cache, else load from user cache
  },
  methods: {
    isTransporterScopedUser (user = null) {
      const targetUser = user || this.signedInUser
      return isAuthorized(targetUser, 'transporter') && !isAuthorized(targetUser, 'staff')
    },
    getAttachedTransportationOwnerUsers (user = null) {
      const targetUser = user || this.signedInUser
      const transportationOwnerUsers = targetUser && Array.isArray(targetUser.transportationOwnerUsers)
        ? targetUser.transportationOwnerUsers
        : []
      return transportationOwnerUsers.filter((item) => item && item.transportationOwnerId)
    },
    isAccountAttachedToUser (accountId, user = null) {
      if (!accountId) {
        return false
      }

      const attachedOwnerUsers = this.getAttachedTransportationOwnerUsers(user)
      return !!attachedOwnerUsers.find((item) => String(item.transportationOwnerId) === String(accountId))
    },
    async resolveMostRecentAttachedAccount (user = null) {
      const targetUser = user || this.signedInUser
      const mostRecentOwnerUser = getMostRecentTransportationOwnerUser(targetUser)
      if (!mostRecentOwnerUser) {
        return null
      }

      const ownerFromRelation = mostRecentOwnerUser.transportationOwner
      if (ownerFromRelation && ownerFromRelation.id) {
        return ownerFromRelation
      }

      return this.$store.dispatch(D_GET_TRANSPORTATION_OWNER, { id: mostRecentOwnerUser.transportationOwnerId })
    },
    async ensureTransporterSelectedAccount () {
      const currentUser = this.$store?.state?.credentials?.user
      if (!this.isTransporterScopedUser(currentUser)) {
        return
      }

      this.signedInUser = currentUser
      const currentSelectedAccount = this.$store.getters.getSelectedTransportationOwner
      if (currentSelectedAccount && currentSelectedAccount.id && this.isAccountAttachedToUser(currentSelectedAccount.id, currentUser)) {
        this.selectedAccount = currentSelectedAccount
        return
      }

      const fallbackAccount = await this.resolveMostRecentAttachedAccount(currentUser)
      if (fallbackAccount && fallbackAccount.id) {
        this.$store.commit(C_SET_SELECTED_TRANSPORTATION_OWNER, fallbackAccount)
        this.$store.dispatch(D_SET_TO_USER_CACHE, { key: 'selectedAccountId', value: fallbackAccount.id, expiryInSeconds: null })
        this.selectedAccount = fallbackAccount
      }
    },
    onResize () {
      const appToolbarHeight = this.$refs.appToolbar?.computedHeight || 0
      this.$store.commit(C_SET_TOOLBAR_HEIGHT, appToolbarHeight)
      const appFooterHeight = this.$refs.appFooter?.height || 0
      this.$store.commit(C_SET_FOOTER_HEIGHT, appFooterHeight)
    },
    async clearSelectedAccount () {
      if (this.isTransporterScopedUser()) {
        await this.ensureTransporterSelectedAccount()
        return
      }

      this.$store.commit(C_SET_SELECTED_TRANSPORTATION_OWNER, null)
      this.$store.dispatch(D_SET_TO_USER_CACHE, { key: 'selectedAccountId', value: null, expiryInSeconds: null })
      this.$router.push({ name: this.$route.name, params: { accountId: 0 } }).catch(_ => {})
      this.forceRootViewRefresh()
    },
    forceRootViewRefresh () {
      this.$data.rootViewKey = Date.now()
    },
    isCurrentRouteMatchForSubNav (subItem) {
      const targetRouteName = subItem && subItem.routeName ? subItem.routeName : null
      if (!targetRouteName || !this.$route || this.$route.name !== targetRouteName) {
        return false
      }

      const targetParams = subItem && subItem.params ? subItem.params : {}
      const targetParamKeys = Object.keys(targetParams)
      if (!targetParamKeys.length) {
        return true
      }

      const currentParams = this.$route.params || {}
      for (let i = 0; i < targetParamKeys.length; i += 1) {
        const key = targetParamKeys[i]
        if (String(currentParams[key] || '') !== String(targetParams[key] || '')) {
          return false
        }
      }

      return true
    },
    handleSubNavClick (subItem) {
      // if (this.isCurrentRouteMatchForSubNav(subItem)) {
      //   return
      // }
      this.forceRootViewRefresh()
    },
    transportationOwnersChange (val) {
      this.currentlySelectedOwner = val
    },
    initUserAndNavigation () {
      this.signedInUser = this.$store?.state?.credentials?.user
      const hideNavigation = this.$route?.meta?.hideNavigation

      if (hideNavigation) {
        this.displayNavigationAndMenu = false
      } else if (this.signedInUser && !hideNavigation) {
        this.displayNavigationAndMenu = true
      } else {
        this.displayNavigationAndMenu = false
      }
    }
  },
  beforeCreate () {
    // this.$store.dispatch(D_GET_SIGNED_IN_USER).catch(_ => {})
  },
  beforeDestroy () {
    if (typeof unwatchUser === 'function') {
      unwatchUser()
    }

    if (typeof unwatchRouteNavigation === 'function') {
      unwatchRouteNavigation()
    }

    if (typeof unwatchSelectedAccount === 'function') {
      unwatchSelectedAccount()
    }
  }
}

function _populateItemsByUser () {
  let items = []
  const user = this.$store?.state?.credentials?.user

  if (user) {
    items = [{
      icon: 'fal fa-sign-out-alt',
      title: 'Sign out',
      routeName: 'signout'
    }]

    const isStaff = isAuthorized(user, 'staff')
    const isAdmin = isAuthorized(user, 'admin')
    const isInvestorOnly = isOnlyInvestorFn(user)
    const isTransporter = isAuthorized(user, 'transporter')
    let isTransporterOwner, isTransporterAdmin

    if (user.transportationOwnerUsers) {
      const accountId = Number(this.$router?.currentRoute?.params?.accountId || '0')
      const transportationOwnerUser = this.transportationOwnerUser || user.transportationOwnerUsers.find(o => (o.transportationOwnerId === accountId))
      isTransporterOwner = hasTransportationRole(user, 'OWNER', accountId, transportationOwnerUser)
      isTransporterAdmin = hasTransportationRole(user, 'ADMIN', accountId, transportationOwnerUser) // transportationOwnerUser
    }

    const isVendor = isAuthorized(user, 'vendor')
    const accountId = this.selectedAccount ? this.selectedAccount.id : 0
    const route = this.$route || {}

    items.push({
      icon: 'fal fa-chart-bar',
      title: 'Dashboard',
      routeName: 'dashboard-group',
      subItems: [
        {
          icon: 'fal fa-tachometer-alt',
          title: 'Summary',
          routeName: 'dashboard'
        },
        {
          icon: 'fal fa-file-chart-line',
          title: 'Reports',
          routeName: 'dashboard-reports'
        }
      ],
      isDefaultOpen: Boolean(
        route.name === 'home' ||
        route.name === 'dashboard' ||
        route.name === 'dashboard-reports' ||
        route.matched.some((o) => (o.name === 'dashboard' || o.name === 'dashboard-reports'))
      )
    })

    if (isStaff) {
      let staffChildren = [
        {
          icon: 'fal fa-user-shield',
          title: 'SmartTransit Staff',
          routeName: 'staff'
        },
        {
          icon: 'fal fa-user-tie',
          title: 'Agents',
          routeName: 'agents'
        },
        {
          icon: 'fal fa-users-class',
          title: 'Passengers',
          routeName: 'passengers'
        },
        {
          icon: 'fal fa-route',
          title: 'Routes and Events',
          routeName: 'routes'
        },
        {
          icon: 'fal fa-sign',
          title: 'Bus Stops',
          routeName: 'bus-stops'
        },
        {
          icon: 'fal fa-money-check-edit-alt',
          title: 'Transportation Fares',
          routeName: 'transportation-fares'
        }
      ]

      if (isAdmin) {
        staffChildren.push({
          icon: 'fal fa-gifts',
          title: 'Promotions',
          routeName: 'promotions'
        })
        staffChildren.push({
          icon: 'fal fa-sliders-h',
          title: 'Advanced Settings',
          routeName: 'advanced-settings'
        })
      }

      if (isInvestorOnly) {
        const investorDeniedStaffRoutes = ['staff', 'agents', 'transportation-fares']
        staffChildren = staffChildren.filter((o) => investorDeniedStaffRoutes.indexOf(o.routeName) === -1)
      }

      items.push({
        icon: 'fal fa-user-shield',
        title: 'Staff Resources',
        routeName: 'staff-resources-group',
        subItems: staffChildren,
        isDefaultOpen: !!((!isTransporter && isStaff) || route.matched.find((o) => (staffChildren.map(o => o.routeName).includes(o.name))))
      })
    }

    if (isStaff || isTransporter) {
      let transportChildren = [
        {
          icon: 'fal fa-users',
          title: 'Accounts',
          routeName: 'transportation-accounts'
        },
        {
          icon: 'fal fa-bus',
          title: 'Vehicles',
          params: { accountId },
          routeName: 'transportation-accounts-vehicles'
        },
        {
          icon: 'fal fa-location-circle',
          title: 'Realtime Map',
          params: { accountId },
          routeName: 'transportation-accounts-vehicles-realtime'
        }
      ]

      if (isTransporter && (!isStaff || isAdmin)) {
        transportChildren.splice(1, 0, {
          icon: 'fal fa-ticket-alt',
          title: 'Revenue',
          params: { accountId },
          routeName: 'transportation-accounts-purchases'
        })

        transportChildren.push(
          {
            icon: 'fal fa-address-card',
            title: 'Owners/Users',
            params: { accountId },
            routeName: 'transportation-accounts-users'
          }
        )
      }

      if (isAdmin || isTransporterOwner || isTransporterAdmin) {
        transportChildren.splice(1, 0, {
          icon: 'fal fa-envelope-open-dollar',
          title: 'Manage Payouts',
          params: { accountId },
          routeName: 'transportation-accounts-payouts'
        })
      }

      if (isInvestorOnly) {
        const investorDeniedTransportRoutes = ['transportation-accounts', 'transportation-accounts-payouts', 'transportation-accounts-users']
        transportChildren = transportChildren.filter((o) => investorDeniedTransportRoutes.indexOf(o.routeName) === -1)
      }

      items.push({
        icon: 'fal fa-users',
        title: 'Transportation Accounts',
        routeName: 'transportation-accounts-group',
        subItems: transportChildren,
        isDefaultOpen: Boolean((!isStaff && isTransporter) || route.name === 'transportation-accounts' || route.matched.find((o) => (o.name === 'transportation-accounts')))
      })
    }

    if (isStaff || isVendor) {
      let transportChildren = [
        {
          icon: 'fal fa-money-check-alt',
          title: 'Passenger Transactions',
          routeName: 'vendor-passenger-transactions'
        }
      ]

      items.push({
        icon: 'fal fa-user-headset',
        title: 'Vendor Resources',
        routeName: 'vendor-resources-group',
        subItems: transportChildren,
        isDefaultOpen: Boolean((!isStaff && isVendor) || route.name === 'vendor-passenger-transactions' || route.matched.some((o) => (o.name === 'vendor-passenger-transactions')))
      })
    }
  }
  return items
}
